export type AlertContext = {
    alertTitle: string
    alertMessage: string
}
export type AlertPropaty = {
    success: AlertContext
    info: AlertContext
    worning: AlertContext
    error: AlertContext
} | undefined
export enum ClosedReason {
    couponUseageLimit = 'couponUseageLimit',
    expired = 'expired',
    maintenance = 'maintenance',
    alreadyRequested = 'alreadyRequested',
    campaignMaintenance = 'campaignMaintenance',
    notKateneMember = 'notKateneMember'
}
